<template>
  <div :id='id' class="dropdown-container">
    <div class="dropdown padding-reset margin-reset grid-12">
      <button @click="show = !show" class="width_full">
        {{ selectedItemOverride || defaultValue || defaultText }}&nbsp;
        <i class="fa fa-caret-down" aria-hidden="true"></i>
      </button>
      <div id="myDropdown" class="dropdown-content row" v-if="show">
        <ul class='grid-12'>
          <li @click="dropdownItemClick($event, value)" v-for="value in values">{{ value.name }}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { find } from 'lodash'
export default {
  data () {
    return {
      show: false,
      selectedItemProxy: null
    }
  },
  props: {
    'list': {
      required: true
    },
    'id': {
      required: true
    },
    'defaultValue': {
      required: false
    },
    'defaultText': {
      required: true
    },
    'selectedItem': {
      required: false
    }
  },
  watch: {
    list () {
      this.$emit('input', this.findDefaultObject(this.selectedItemOverride || this.defaultText))
    }
  },
  computed: {
    values () {
      return this.list
    },
    selectedItemOverride: {
      get () {
        this.selectedItemProxy
        this.selectedItem
        return (this.selectedItemProxy) ? this.selectedItemProxy : this.selectedItem
      },
      set (value) {
        this.selectedItemProxy = value
      }
    }
  },
  created () {
    this.$emit('input', this.findDefaultObject(this.selectedItemOverride || this.defaultText))
    window.eventBus.$on('strayClick', (e) => {
      if (!this.isDescendant(document.getElementById(this.id), e.target)) this.show = false
    })
  },
  methods: {
    dropdownItemClick (e, item) {
      this.show = false
      // this.selectedItem = (item === '(none)') ? null : item.name
      this.selectedItemProxy = item.name
      this.$emit('input', item)
    },
    isDescendant (parent, child) {
      var node = child.parentNode
      while (node !== null) {
        if (node === parent) {
          return true
        }
        node = node.parentNode
      }
      return false
    },
    findDefaultObject (defaultText) {
      return find(this.list, ['name', defaultText])
    }
  }
}
</script>

<style scoped>

.dropdown-container {
  position: relative;
}

@media only screen and (min-width: 100px) {
  .dropdown {
    display: inline-block;
  }
}

@media only screen and (min-width: 1000px) {
  .dropdown {
    display: inline-block;
    min-width: 16rem;
  }
}

.dropdown.grid-4 {
  padding: 0;
}

button {
  font-size: 1.1rem;
  text-transform: uppercase;
  letter-spacing: 0.1rem;
  border-radius:.3rem;
  background-color: #443c3c
}

.dropdown-content {
  display: block;
}

.dropdown-content ul {
  background-color: #f9f9f9;
  overflow-y: auto;
  max-height: 35rem;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  padding: 0;
  margin: 0;
  text-align: center;
  position: absolute;
  z-index: 3;
}

.dropdown-content li {
  color: black;
  font-size: 1.2rem;
  padding: 1rem .5rem;
  text-decoration: none;
  display: block;
}

.dropdown li:hover {
  background-color: #f1f1f1
}

.show {
  display:block;
}

.grid-12.padding-reset {
  padding: 0;
}
.grid-12.margin-reset {
  margin: 0;
}

.padding-reset.[class*='grid-']:first-of-type {
  padding-left: 0;
}
.padding-reset.[class*='grid-']:last-of-type {
  padding-left: 0;
}

</style>



// WEBPACK FOOTER //
// Dropdown.vue?525124a6